export const FormLabel = ({
  children,
  className = "",
  isOptional = false,
  ...props
}) => {
  return (
    <label
      {...props}
      className={`text-ink-ink dark:text-ink-white text-sm font-semibold ${className}`}
    >
      {children && <span>{children}</span>}
      {isOptional ? (
        <span className="text-xs text-ink-hex-aaaaaa ml-[5px] font-normal">(Optional)</span>
      ) : null}
    </label>
  );
};
